import { render } from "./SuccessBanner.vue?vue&type=template&id=d5df38ae&scoped=true"
import script from "./SuccessBanner.vue?vue&type=script&lang=js"
export * from "./SuccessBanner.vue?vue&type=script&lang=js"

import "./SuccessBanner.vue?vue&type=style&index=0&id=d5df38ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5df38ae"]])

export default __exports__